import MatriusTaskPopup from './MatriusTaskPopup'
import MatriusTrainer from './MatriusTrainer'
import { mapState } from 'vuex'
import { popup_mix } from '../../../mixins/popup_mix'
import swal from 'sweetalert'

export const matrius_task = {
  components: { MatriusTaskPopup, MatriusTrainer },
  mixins: [ popup_mix ],
  data() {
    return {
      matriusTask: null,
      completed: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    getMatriusTask() {
      this.http.post('onGetMatriusStudentTask', { student_id: this.user.id }).then(res => {
        if (!Array.isArray(res.data)) {
          this.matriusTask = res.data
          
          this.matriusTask.trainers.forEach(item => {
            item.total = 0
          })
          console.log(this.matriusTask)
        }
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
    }
  }
}